import paymentApi from './paymentApi';
export { paymentApi };
export default paymentApi;